import React, {} from 'react';
import "./styles.scss";
import { SurahTable } from '../../components/tables/surahTable/SurahTable';

export const Surahs = () => {

  return (
    <div className='data-table'>
      <SurahTable />
    </div>
  );
};